import {
    useTable,
    List,
    EditButton,
    ShowButton,
    DeleteButton,
    PageHeaderProps,
    useModalForm,
    useSimpleList,
    useForm
} from '@refinedev/antd';
import { BaseRecord, useDataProvider, useMany, useNavigation } from '@refinedev/core';
import { CrudFilters } from '@refinedev/core/dist/interfaces';
import { Table, Space, Input, Radio, Button, Modal, Breadcrumb, Select, Card, Avatar, Row, Col, FloatButton, Popover } from 'antd'
import { FilterDropdownProps } from 'antd/lib/table/interface';
import { useSchemaDB } from 'hooks/useSchemaDB';
import React, { useEffect, useState } from 'react'
import { FieldDB, opts, TableDB, ConfigCard, ChildForm } from '../../../src/interfaces/schemaDB';
import Cw8Create from './Cw8Create';
import { SearchOutlined, EditOutlined, CustomerServiceOutlined, MenuOutlined, AppstoreOutlined, SaveOutlined, PlusOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { Typography, List as AntdList, Form, DatePicker,} from "antd";
import Cw8Form from './Cw8Form';
import { EllipsisOutlined, SettingOutlined, CloseCircleOutlined } from '@ant-design/icons';
import Cw8ListFilter from './Cw8ListFilter';
import Cw8Edit from './Cw8Edit';
import Cw8EditWrapper from './Cw8EditWrapper';
import { FragmentPubsEdit } from 'pages/fragmentpubs';
import { config } from "config";
const { Title, Text } = Typography;

interface Cw8ListProps {
    resourceName: string
    filterList?: CrudFilters
    titleList?: string
    showCards? : Boolean
    configCard?: ConfigCard
    createModal ?: boolean
    editModal ?: boolean
}

const Cw8List = ({resourceName, filterList, titleList, showCards, configCard, createModal, editModal} : Cw8ListProps ) => {


    const dataProvider = useDataProvider();
    const defaultDataProvider = dataProvider(); // return default data provider
    const [isCards, setIsCards] = useState(showCards)
    const { edit } = useNavigation();
    const { Meta } = Card;
    const { tableProps, setFilters, searchFormProps  } = useTable({
        
        resource: resourceName,
        filters:{
            permanent : filterList,
            mode: 'server'
        },
            onSearch: (params: any) => {
                const filters: CrudFilters = [];
                for (let field in params) {
                        filters.push(
                            {
                                field: field,
                                // operator: "containss", //esto sirve para air table para custom es eq
                                operator: "eq", //esto sirve para air table para custom es eq
                                value: params[field],
                            }
                        )                    
                }

                if (dataProvider) {
                    const providerName = dataProvider;
                    console.log(dataProvider);
                    console.log(typeof defaultDataProvider);
                    // console.log(refineProps);
                }
                return filters;
            }        
    });


    const {getTable, getListField, getProperty } = useSchemaDB({nameTable:resourceName})
    const table = getTable(resourceName)
    
    
    const {
        modalProps: editModalProps,
        formProps: editFormProps,        
        show: editModalShow 
        , id : IdBase
    } = useModalForm({
        action: "edit",
        resource:resourceName,
        redirect : false        
    });


    // console.log(IdBase);

    const fieldList = getListField(table?table?.length>0?table[0]:null:null, undefined, editModal?editModalShow:undefined) 
    const ph:PageHeaderProps = {title:titleList }
    
    const {         
        modalProps: createModalProps,
        formProps: createFormProps,
        show: createModalShow
        // , onFinish
        // , close : closeModalCreate
        // , submit : submitModalCreate
    } = useModalForm({
            action: "create",
            resource:resourceName,
            redirect : false,

    });



    const { listProps, searchFormProps : searchCardFormProps } = useSimpleList({
        resource: resourceName,
        filters:{
            permanent : filterList,
            mode: 'server'
        },        
        onSearch: (params: any) => {
            const filters: CrudFilters = [];
            for (let field in params) {
                    filters.push(
                        {
                            field: field,
                            // operator: "containss", //esto sirve para air table para custom es eq
                            operator: "contains", //esto sirve para air table para custom es eq
                            value: params[field],
                        }
                    )                    
            }
            return filters;
        }   
    });

    const getAvatar = ( item: any ) =>{

        let img : String = ""
        if (Array.isArray(item)) {
                item.forEach( item =>{
                    img = item.thumbnails.large.url
                } )
          }
          if(img == ""){
              img = "data:image/png;base64,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"
          }
          return img
    }


    const renderItem = (item: any ) => {
        const { title, hit, content, id } = item;
        const fieldTitleRender = configCard?.fieldTitle?configCard.fieldTitle:'title';
        const fieldDescRender = configCard?.fieldDesc?configCard.fieldDesc:'description';
        const fieldImage = configCard?.fieldImg?configCard.fieldImg:'';


        return (
            <Card
                style={{margin: 10}}
                cover={
                    <img
                    alt="example"
                    src={getAvatar(getProperty(item, "img")) as string}
                    />
                }
                actions={[
                    <EditButton 
                        hideText
                        size="small"
                        recordItemId={item.id}
                        resource={resourceName}
                        onClick={ editModal?()=>editModalShow(item.id):undefined }
                    />,
                    // <DeleteButton 
                    //     hideText
                    //     size="small"
                    //     recordItemId={item.id}
                    //     resource={resourceName}
                    // />,
                    // <ShowButton 
                    //     hideText
                    //     size="small"
                    //     recordItemId={item.id}
                    //     resource={resourceName}
                    // />
                ]}
            >
                <Meta
                    title={ getProperty(item, fieldTitleRender) }
                    description= { getProperty(item, fieldDescRender) }
                /> 
            </Card>
        );
    };

    const { formProps, saveButtonProps, form } = useForm({});    
    const [openFilter, setOpenFilter] = useState(false)

    const crearRecursoBV = async () => {
        try {
            const provider = dataProvider();
            const result = await provider.create({
                resource: "bibliotecaVirtual",
                variables: {
                    bc_apa_doi: "",
                    bc_apa_mes: "Ene",
                    bc_apa_numero: "",
                    bc_apa_paginas: "",
                    bc_apa_tipo_tesis: "",
                    bc_apa_volumen: "",
                    bv_apa_ciudad: "",
                    bv_apa_mes: "Ene",
                    bv_apa_nombre_evento: "",
                    bv_apa_pais: "CO",
                    bv_apa_titulo_libro: "",
                    bv_apa_titulo_revista: "",
                    bv_consultas: "0",
                    bv_dc_ano_publicacion: "2000",
                    bv_dc_autor_apa: "",
                    bv_dc_cobertura: "",
                    bv_dc_colaborador: "",
                    bv_dc_derechos: "1",
                    bv_dc_descripcion: "",
                    bv_dc_editor: "",
                    bv_dc_formato: "pdf",
                    bv_dc_lenguaje: "eng",
                    bv_dc_relacion: "",
                    bv_dc_subject_eng: "",
                    bv_dc_subject_snpi_eng: "",
                    bv_dc_subject_snpi_spa: "",
                    bv_dc_subject_spa: "",
                    bv_dc_tipo: "",
                    bv_dc_title_eng: "",
                    bv_dc_title_por: "",
                    bv_dc_title_spa: "",
                    bv_dc_url_origen: "",
                    bv_dc_url_vpro: "",
                    bv_descargas: "0",
                    bv_inedito: false,
                    bv_mxd: "",
                    bv_vp_activo: false,
                    bv_vp_bibliografia: "",
                    bv_vp_nivel1: "1",
                    bv_vp_nivel2: "1",
                    bv_vp_observacion: "",
                    bv_vp_tamano: "1",
                    bv_vp_url_fuente: "",
                },
            });
            edit("bibliotecaVirtual", result.data.bv_id);
            console.log("Recurso creado:", result.data.bv_id);
        } catch (error) {
            console.error("Error al crear:", error);
        }
    }



    // const onFinishHandler = (values:any) => {
    //     onFinish(values);
    //     console.log("Finish")
    //     closeModalCreate();
    // };

    // const handleOk = () => {
    //     submitModalCreate();
    //     // closeModalCreate();
    // };

    return (

        table?(
        <>
            <Row gutter={16}>
                <Col span={openFilter?18:24}>

                    {
                        !isCards?(
                            <List  
                                headerProps={ titleList?ph:undefined } 
                                createButtonProps={filterList || createModal?{
                                    onClick: () => { createModalShow(); },
                                }:{}}
                                breadcrumb = {<span></span>}
                                headerButtons={({ defaultButtons }) => (
                                    <>
                                        {
                                            showCards?(
                                                <>
                                                <Button type={!isCards?"primary":"default"} onClick ={ ()=> setIsCards(false) } icon={<MenuOutlined/>}>List</Button>
                                                <Button type={ isCards?"primary":"default"} onClick ={ ()=> setIsCards(true)  } icon={<AppstoreOutlined />}>Grid</Button>   
                                                </>
                                            ):null
                                        }
                                        {resourceName === "bibliotecaVirtual" ? <Button type={"primary"} onClick ={ () => crearRecursoBV() } icon={<PlusOutlined/>}>Crear</Button> : <>{defaultButtons}</> }
                                        {resourceName === "infografia" && 
                                        <Button
                                        type='primary'
                                        shape="default"
                                        icon={<ArrowRightOutlined />}
                                        href="https://hpa.lugnia.com/webhook/infografias-ia-gen"
                                        target="_blank"
                                        >
                                            Crear infografía con IA
                                        </Button>}
                                        <Button shape="circle" onClick ={ ()=> setOpenFilter(!openFilter) } icon={<SearchOutlined/>}></Button>
                                    </>
                                )}
                            >
                                <Table {...tableProps} rowKey="id" 
                                    columns={fieldList} 
                                    tableLayout = {"fixed"}
                                    scroll={{ x: fieldList.length<=5?0:fieldList.length*150, y: 420 }}
                                />
                            </List>                        
                        ):(
                            <List
                                headerProps={ titleList?ph:undefined } 
                                createButtonProps={filterList || createModal?{
                                    onClick: () => { createModalShow(); },
                                }:{}}                            
                                breadcrumb = {<span></span>}

                                headerButtons={({ defaultButtons }) => (
                                    <>
                                        <Button type={!isCards?"primary":"default"} onClick ={ ()=> setIsCards(false) } icon={<MenuOutlined/>}>List</Button>
                                        <Button type={isCards?"primary":"default"} onClick ={ ()=> setIsCards(true)  } icon={<AppstoreOutlined />}>Grid</Button>                                      
                                        {defaultButtons}
                                        <Button shape="circle" onClick ={ ()=> setOpenFilter(!openFilter) } icon={<SearchOutlined/>}></Button>
                                    </>
                                )}                        
                            >
                                <AntdList 
                                    grid={{
                                        gutter: 16,
                                        column: configCard?.numColums?configCard.numColums:6,
                                    }}   
                                    {...listProps} 
                                    renderItem={ configCard?.renderItem?configCard.renderItem:renderItem} />
                            </List>
                        )                        
                    }
                </Col>
                <Col span={openFilter?6:0}>
                    <Card title="Filtrar"
                        extra={<a href="#"><Button type={"text"} size={"large"} style={{right:-10}} onClick={ () => setOpenFilter(!openFilter)} icon={<CloseCircleOutlined/>}></Button></a>}
                    >
                        <Cw8ListFilter 
                            formProps={isCards?searchCardFormProps:searchFormProps} 
                            fieldList={fieldList}  
                            resourceName={resourceName}
                            form = {form}
                        />
                    </Card>
                </Col>
            </Row>

            <Modal {...createModalProps}
        // footer={[
        //     <Button key="back" >
        //       Return...
        //     </Button>,
        //     <Button key="submit" type="primary"  onClick={handleOk}>
        //       Submit...
        //     </Button>,

        //   ]}
            >
                <Cw8Create
                    resourceName={resourceName}
                    filterList = {filterList}
                    createFormProps = {createFormProps}
                    // onFinish = {onFinishHandler}
                ></Cw8Create>
            </Modal>

            <Modal 
                {...editModalProps}
            >

                {/* <FragmentPubsEdit></FragmentPubsEdit> */}
                {/* <Cw8Edit
                    resourceName={resourceName}
                    // filterList = {filterList}
                    editFormProps = {editFormProps}
                    modal = {editModal}
                    childrenForms = {childrenFormsSecciones}
                    id ={IdBase}
                ></Cw8Edit> */}

                <Cw8EditWrapper
                    resourceLabel = {titleList}
                    resourceName = {resourceName}
                    id = {IdBase}
                    childrenForms = {table?(table.length>0?(table[0].childrenForms?table[0].childrenForms:[]):[]):[]}  //ESTO DEBE SACARSE DE ALGUN LADO COMO DEL SCHEMA   
                    // childrenForms = {[]}  //ESTO DEBE SACARSE DE ALGUN LADO COMO DEL SCHEMA   
                    modal = {editModal}  
                    editFormProps = {editFormProps}
                />
                    
            </Modal>            
        </>



        ):(<p>Loading ...</p>)
    )
}

export default Cw8List

